import { render, staticRenderFns } from "./BrokenLinksPage.vue?vue&type=template&id=1cfe5a74&"
import script from "./BrokenLinksPage.vue?vue&type=script&lang=js&"
export * from "./BrokenLinksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports